module.exports = __webpack_public_path__ + "img/hw-s10.6109b567.svg";